import theme from "config/theme";
import styled from "styled-components";

const Container = styled.div`

`
const Agency = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    & * {
        color: ${theme.colors.primary};
        font-size: 4rem;
        font-family: AyeshaDisplay;
        vertical-align: baseline;
    }
    & img {
        height: 4rem;
    }
`
const Tulna = styled.div`
    display: flex;
    gap: 0.5rem;

    & * {
        color: #888;
        font-size: 0.8rem;
        font-family: Arial, sans-serif;
    }
    & img {
        height: 0.8rem;
        opacity: 0.5;
    }
`

const SiteHeader = () => {
    return (
        <Container>
            <Agency>
                <img src={require('assets/img/agency-logo.png')} alt='big-little-hearts-logo' />
                <div>
                    <h1>Big Little Hearts</h1>
                    <Tulna>
                        <h2>In cooperation with the Littles Adoption Alliance of Tulna</h2>
                        <img src={require('assets/img/tulna-flag.png')} alt='tulna-flag' />
                    </Tulna>
                </div>
            </Agency>
        </Container>
    )
}

export default SiteHeader;